export interface CacheConfig {
  ttl: number;        // Time to live in milliseconds
  patterns: string[]; // URL patterns to match
}

export interface CacheEntry {
  data: any;           // API response data
  timestamp: number;   // Cache creation time
  ttl: number;         // Time to live in milliseconds
  url: string;         // Original URL for debugging
  method: string;      // HTTP method
  storeId: string;     // Store identifier
}

// Cache configuration rules
export const CACHE_RULES = {
  // Long-term cache (1 hour) - Very stable metadata
  LONG_TERM: {
    ttl: 60 * 60 * 1000, // 1 hour
    patterns: [
      '/template_reports',
      '/plugins',
      '/plugin_packages',
      '/email_templates',
      '/tags',
    ],
  },

  // Medium-term cache (15 minutes) - Semi-static data
  MEDIUM_TERM: {
    ttl: 15 * 60 * 1000, // 15 minutes
    patterns: [
      '/api/color-rules',
    ],
  },

  // Semi-dynamic cache (30 minutes) - User-editable data with smart invalidation
  SEMI_DYNAMIC: {
    ttl: 30 * 60 * 1000, // 30 minutes
    patterns: [
      '/segment',
      '/dashboard',
      '/dashboards',
      '/published_dashboards',
      '/system_dashboards',
    ],
  },

  // Note: Any API not listed above will NOT be cached
  // This includes real-time data like reports, analytics, approvals, etc.
} as const;

// Smart invalidation rules for user-editable data
export const SMART_INVALIDATION_RULES = {
  '/segment': ['/segment', '/segments', '/product-segments'],
  '/dashboard': ['/dashboard', '/dashboards', '/published_dashboards', '/system_dashboards'],
  // A card mutation (add / edit / remove) must invalidate the parent dashboard's
  // cached card list — otherwise `/dashboards/:id/cards` keeps serving the
  // stale snapshot for up to 30 min and the UI silently shows a pre-mutation
  // dashboard until the user reloads the tab.
  '/cards': ['/dashboard', '/dashboards', '/published_dashboards', '/system_dashboards'],
} as const;

export const CACHE_KEY_PREFIX = 'warbler_cache';
export const MAX_CACHE_ENTRIES = 1000; // Prevent unlimited growth
export const MAX_CACHE_SIZE_KB = 5000; // 5MB storage limit
export const CLEANUP_THRESHOLD_KB = 4000; // Start cleanup at 4MB
